import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust according to your Firebase setup
import NavbarAdmin from '../components/NavbarAdmin';
import './styles/ManageStatDom.css';

const ManageComite = () => {
  const [comiteData, setComiteData] = useState([]);

  useEffect(() => {
    const fetchComiteData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'comite'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setComiteData(data);
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchComiteData();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer ce document ?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, 'comite', id));
        alert("Document supprimé avec succès!");

        // Refetch data to update the table
        const querySnapshot = await getDocs(collection(db, 'comite'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setComiteData(data);
      } catch (error) {
        console.error("Error deleting document: ", error);
      }
    }
  };



  const headingStyle = {
    fontSize: '2rem', /* Adjust the font size as needed */
    color: '#cc6699', /* Dark grey color for readability */
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0', /* Space above and below the heading */
    textAlign: 'center', /* Centers the heading text */
    borderBottom: '2px solid #ddd', /* Adds a subtle border below the heading */
    paddingBottom: '10px' /* Adds space between the text and the border */
  };

  const inputStyle = {
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ddd',
    width: '100%',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  const formStyle = {
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    maxWidth: '600px',
    margin: '0 auto',
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
        <h2 style={headingStyle}>Gérer Comité</h2>
        <table>
          <thead>
            <tr>
              <th>Lien Drive</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {comiteData.map(comite => (
              <tr key={comite.id}>
                
                <td>{comite.lien}</td>
                <td>
                
                  <button
                    className="supprimer"
                    onClick={() => handleDelete(comite.id)}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

       
        
      </div>
    </div>
  );
};

export default ManageComite;
